import React, { ComponentType, FC } from 'react'
import { Controller, ControllerProps } from 'react-hook-form'
import {
  ITruckAutocompleteProps,
  TruckAutocomplete,
} from '../../../../pages/shipment-details/components/ShipmentCarrierInfo/form/TruckAutocomplete'

export type IBaseControllerProps = ControllerProps<ComponentType<ITruckAutocompleteProps>>

export interface IControlledTruckNumberAutocompleteProps
  extends Pick<IBaseControllerProps, 'control' | 'name'> {
  carrierApplicationId: string
  defaultValue?: string
  TruckAutocompleteProps?: Omit<
    ITruckAutocompleteProps,
    'name' | 'control' | 'carrierApplicationId' | 'ref' | 'value' | 'onBlur' | 'onChange'
  >
}

export const ControlledTruckNumberAutocomplete: FC<IControlledTruckNumberAutocompleteProps> = ({
  TruckAutocompleteProps,
  carrierApplicationId,
  control,
  defaultValue,
  name,
}) => {
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      render={props => {
        return (
          <TruckAutocomplete
            {...TruckAutocompleteProps}
            {...props}
            carrierApplicationId={carrierApplicationId}
            truckNumber={defaultValue}
          />
        )
      }}
    />
  )
}

export default ControlledTruckNumberAutocomplete
